<template>
    <v-card>
        <v-card-title>
            <v-title>Manage Iseek Wholesaler</v-title>
        </v-card-title>
        <v-card-text>
            <v-layout wrap>
                <v-flex xs3>
                    <v-text-field
                            name="Search"
                            label="Search"
                            v-model="search"
                            append-icon="search"
                    ></v-text-field>
                </v-flex>
            </v-layout>
            <v-data-table
                    :headers="headers"
                    :items="filterData()"
                    :search="search"
                    item-key="index"
                    class="elevation-1"
            >
                <template v-slot:items="props">
                    <td xs2 md2 lg2>

                        <ValidationProvider name="Id" rules="required" v-slot="{ errors }">

                            <v-text-field
                                    label="Id"
                                    name="Id"
                                    :error-messages="errors"
                                    v-if="isEditing(props)"
                                    v-model="props.item.id"
                            ></v-text-field>
                            <span v-else>{{ props.item.id }}</span>
                        </ValidationProvider>
                    </td>
                    <td>
                        <ValidationProvider name="IseekWholesalerId" rules="required" v-slot="{ errors }">

                            <v-text-field
                                    label="IseekWholesalerId"
                                    name="IseekWholesalerId"
                                    :error-messages="errors"
                                    v-if="isEditing(props)"
                                    v-model="props.item.iseekId"
                            ></v-text-field>
                            <span v-else>{{ props.item.iseekId }}</span>

                        </ValidationProvider>
                    </td>
                    <td>
                        <ValidationProvider name="Name" rules="required" v-slot="{ errors }">

                            <v-text-field
                                    label="Name"
                                    name="Name"
                                    :error-messages="errors"
                                    v-if="isEditing(props)"
                                    v-model="props.item.name"
                            ></v-text-field>
                            <span v-else>{{ props.item.name }}</span>
                        </ValidationProvider>
                    </td>
                    <td class="pl-3">
                        <v-tooltip bottom :disabled="isEditingItem">
                            <template v-slot:activator="{ on }">
                                <v-btn
                                        icon
                                        v-if="!isEditing(props)"
                                        @click="
                    setToEditing(props);
                    isEditingItem = true;
                  "
                                        class="my-0 mx-1"
                                        v-on="on"
                                        :disabled="isEditingItem"
                                >
                                    <v-icon color="teal">edit</v-icon>
                                </v-btn>
                            </template>
                            <span>Edit</span>
                        </v-tooltip>

                        <v-tooltip bottom :disabled="isEditingItem">
                            <template v-slot:activator="{ on }">
                                <v-btn
                                        icon
                                        v-if="!isEditing(props)"
                                        @click="
                    deleteWholesalers(props.item);
                  "
                                        class="my-0 mx-1"
                                        v-on="on"
                                        :disabled="isEditingItem"
                                >
                                    <v-icon color="pink">cancel</v-icon>
                                </v-btn>
                            </template>
                            <span>Delete</span>
                        </v-tooltip>
                        

                        <v-tooltip bottom :disabled="!isEditingItem">
                            <template v-slot:activator="{ on }">
                                <v-btn
                                        icon
                                        v-if="isEditing(props)"
                                        @click="updateWholesaler(props.item)"
                                        class="my-0 mx-1"
                                        v-on="on"
                                >
                                    <v-icon color="teal">save</v-icon>
                                </v-btn>
                            </template>
                            <span>Save</span>
                        </v-tooltip>

                        <v-tooltip bottom :disabled="!isEditingItem">
                            <template v-slot:activator="{ on }">
                                <v-btn
                                        icon
                                        v-if="isEditing(props)"
                                        @click="cancelEdit(props)"
                                        class="my-0 mx-1"
                                        v-on="on"
                                >
                                    <v-icon color="pink">cancel</v-icon>
                                </v-btn>
                            </template>
                            <span>Cancel</span>
                        </v-tooltip>
                    </td>
                </template>
            </v-data-table>
        </v-card-text>
        <v-card-actions class="pr-3 pb-3">
            <v-spacer></v-spacer>
            <v-btn class="primary" @click="addUser()">Create New Iseek Wholesaler</v-btn>
        </v-card-actions>

        <add-iseek-wholesaler :add="add" @close="close()" @save="save"></add-iseek-wholesaler>
    </v-card>
</template>
<script>
    import AddIseekWholesaler from "@/components/admin/add-iseek-wholesaler";
    import { mapActions, createNamespacedHelpers } from "vuex";
    const {
        mapActions: mapWholesalerDetailActions
    } = createNamespacedHelpers(`orders/wholesalerDetail`);
    import { httpError } from "../models/httpError";
    export default {
        name: "manageIseekWholesaler",
        components: { AddIseekWholesaler },
        data () {
            return {
                add: false,
                newMessage: {},
                editingIndex: -1,
                customers: [],
                search: "",
                loading: false,
                isEditingItem: false,
                isAddingItem: false,
                selected: "All",
                disable: false,
                load: false,
                headers: [
                    {
                        text: "Id",
                        sortable: true,
                        value: "id"
                    },
                    {
                        text: "Iseek Wholesaler Id",
                        sortable: true,
                        value: "iseekId"
                    },
                    {
                        text: "Name",
                        sortable: true,
                        value: "name"
                    },
                    {
                        text: "Actions",
                        sortable: true,
                        value: "action"
                    }
                ]
            };
        },
        methods: {
            ...mapWholesalerDetailActions([
                "listIseekWholesalers",
                "updateIseekWholesalers",
                "deleteIseekWholesalers"
            ]),
            getCustomers () {
                let vm = this;
                vm.load = false;

                setTimeout(() => {
                    vm.listIseekWholesalers().then(result => {
                        vm.customers = result;
                    });
                }, 1000);
            },
            isEditing (props) {
                return this.editingIndex == props.index;
            },
            setToEditing (props) {
                this.editingIndex = props.index;
            },
            cancelEdit (props) {
                this.editingIndex = -1;
                this.getCustomers();
                this.isEditingItem = false;
                this.isAddingItem = false;
            },
            addUser (item) {
                this.add = true;
                this.isAddingItem = true;
            },
            close () {
                this.add = false;
            },
            updateWholesaler (editedItem) {
                this.updateIseekWholesalers(editedItem);
                this.isEditingItem = false;
                this.isAddingItem = false;
                this.add = false;
                this.editingIndex = -1;
            },
            getDeleteConfirm() {
                return window.confirm('Do you really want to delete this Wholesaler?')
            },
            deleteWholesalers (editedItem) {
                if(this.getDeleteConfirm())
                {
                    this.deleteIseekWholesalers(editedItem);
                    this.getCustomers();
                    this.isEditingItem = false;
                    this.isAddingItem = false;
                    this.add = false;
                    this.editingIndex = -1;  
                }
            },
            save (editedItem) {
                let vm = this;
                var wholesaler = {}
                wholesaler.iseekId = editedItem.iseekId;
                wholesaler.name = editedItem.name;
                this.updateIseekWholesalers(wholesaler);
                this.isEditingItem = false;
                this.isAddingItem = false;
                this.add = false;
                this.editingIndex = -1;
                editedItem.iseekId = 0;
                editedItem.name = "";
                vm.getCustomers();
            },
            filterData () {
                return this.customers;
            }
        },
        computed: {
        },
        watch: {
            selected: function () {
                this.filterData();
            }
        },
        mounted () {
            this.getCustomers();
        }
    };
</script>
